import { graphql, useStaticQuery } from "gatsby";

/**
 * The WordPress host, taken from `WP_URL` via siteMetadata - the same value the
 * source plugin reads, so it is the backend by definition. Needed to recognise
 * link fields that were saved absolute against WordPress, so they can be
 * rewritten to site-relative paths.
 */
const wpUrlData = () => {
    const data = useStaticQuery(
        graphql`
            {
                site {
                    siteMetadata {
                        wpUrl
                    }
                }
            }
        `
    );

    return data.site?.siteMetadata?.wpUrl;
};

export { wpUrlData };
